<template>
    <div class="card" v-on:click="() => { openLink(link)}">
        <img class="previewImg" :src="path + '/preview.png'">
        <p class="title">{{title}}</p>
        <p>
            <slot></slot>
        </p>  
    </div>
</template>

<script>
export default {
    name: "ProjectCard",
    props: [
        'path',
        'title',
        'link'
    ],
    methods: {
        openLink(str){
            if(str!=undefined && str != ""){
                window.open(str, "_blank")
            }
            
        }
    }
}
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Karla&display=swap');
.card{
    width: 30vw;
    height: 430px;
    /* background-color: rgb(220,220,220); */
    border-radius: 10px;
    overflow: hidden;
    border-style: solid;
    border-color: transparent;
    align-items: center;
    margin-bottom: 10px;
}
.card:hover{
    border-color: rgb(209,192,220);
}
.previewImg{ 
    width: 100%;
    height: auto;
}
p{
    margin-right: 5px;
    margin-left: 5px;
    color: black;
    text-align: justify;
    font-size: 20px;
    font-family: 'Karla', sans-serif;
}
.title{
    font-size: 20px;
    font-family: 'Bebas Neue', cursive;
}

@media only screen and (max-width: 600px) {
    .card{
        width: 40vw;
        height: 300px;
        /* background-color: rgb(220,220,220); */
        border-radius: 10px;
        overflow: hidden;
        border-style: solid;
        border-color: transparent;
        align-items: center;
    }
    p{
        font-size: 16px;
    }
}

</style>